/**
 * WT-21 (16 Oct walk-through): the club's home ground as one line for a venue
 * box, "Name, address" — but not the name twice when the address already
 * starts with it (the default venue read "Testvale Recreation Ground,
 * Testvale Recreation Ground, Testvale, Somerset"). Used by the hub's add
 * session / event forms and the Set up the season wizard.
 *
 * Pure — no imports, no DOM — so node --test can run it
 * (venue.test.mjs beside this file).
 */
export function homeGroundLabel(club) {
  const name = String(club?.home_ground_name || '').trim();
  const addr = String(club?.home_ground_address || '').trim();
  if (!name || !addr) return addr || name;
  const rest = addr.slice(name.length);
  const startsWithName = addr.toLowerCase().startsWith(name.toLowerCase())
    && (rest === '' || /^[\s,.–—-]/.test(rest));
  return startsWithName ? addr : `${name}, ${addr}`;
}
